var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.212,
    height: 35.354,
    viewBox: "0 0 34.212 35.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_504",
    "data-name": "Groupe 504",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_11",
    "data-name": "Ligne 11",
    x2: 31.212,
    transform: "translate(0 16.177)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_12",
    "data-name": "Ligne 12",
    x2: 32.354,
    transform: "translate(15.606 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconOutline);
export default __webpack_public_path__ + "static/media/plusIconOutline.a74500196f8ee550427176e64df47c35.svg";
export { ForwardRef as ReactComponent };